import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateContractDetailSearch } from './lib/contractDetailSearch';
import { validateContractNewSearch } from './lib/contractNewSearch';
import { validateContractsSearch } from './lib/contractsSearch';

export const contractsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/contracts',
  component: lazyRouteComponent(() => import('./pages/ContractsPage'), 'ContractsPage'),
  validateSearch: validateContractsSearch,
});

/**
 * Starting a contract is a page, not a dialog: two steps with a review in
 * between, deep-linkable from a player with `?playerId=`. Static, so the router
 * ranks it above `$contractId`.
 */
export const contractNewRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/contracts/new',
  component: lazyRouteComponent(() => import('./pages/ContractNewPage'), 'ContractNewPage'),
  validateSearch: validateContractNewSearch,
});

export const contractDetailRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/contracts/$contractId',
  component: lazyRouteComponent(() => import('./pages/ContractDetailPage'), 'ContractDetailPage'),
  validateSearch: validateContractDetailSearch,
});

export const contractsRoutes = [contractsRoute, contractNewRoute, contractDetailRoute];
